// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MPxhaErNmxCLwNZwLNta{margin-top:-8px;margin-bottom:32px}.m30mlI7ChTweB_aPn6Ok{margin-top:-4px}`, "",{"version":3,"sources":["webpack://./src/pages/broadcasts/ui/BroadcastView/ui/ReviewBroadcast/alerts/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,eAAA,CACA,kBAAA,CAEF,sBACE,eAAA","sourcesContent":[".wrap {\n  margin-top: -8px;\n  margin-bottom: 32px;\n}\n.wrapAutoRechargeBtn {\n  margin-top: -4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `MPxhaErNmxCLwNZwLNta`,
	"wrapAutoRechargeBtn": `m30mlI7ChTweB_aPn6Ok`
};
export default ___CSS_LOADER_EXPORT___;
